module.exports = __webpack_public_path__ + "img/by-sa.eaf9e50b.png";